import api from './api';

let cachedUsers = null;
let cacheTs = 0;
const CACHE_TTL = 10 * 60 * 1000; // 10 min

async function getGraphToken(msalInstance) {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return null;

  try {
    const resp = await msalInstance.acquireTokenSilent({
      scopes: ['User.Read.All', 'Application.Read.All'],
      account: accounts[0],
    });
    return resp.accessToken;
  } catch {
    try {
      const resp = await msalInstance.acquireTokenPopup({
        scopes: ['User.Read.All', 'Application.Read.All'],
      });
      return resp.accessToken;
    } catch {
      return null;
    }
  }
}

export async function fetchUserDirectory(msalInstance) {
  if (cachedUsers && (Date.now() - cacheTs) < CACHE_TTL) {
    return cachedUsers;
  }

  if (!msalInstance) return cachedUsers || [];

  const token = await getGraphToken(msalInstance);
  if (!token) return cachedUsers || [];

  try {
    const { data } = await api.get('/api/users/directory', {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (Array.isArray(data.users)) {
      cachedUsers = data.users;
      cacheTs = Date.now();
      return data.users;
    }
    return cachedUsers || [];
  } catch {
    return cachedUsers || [];
  }
}
